import { Metric } from '@models';

export const metrics: { [key: string]: Metric } = {
  time: {
    value: 0,
    unit: 'Second',
    id: 'ca857a51-6e39-47fc-98e4-9021141d967e',
  },
  grasperLeftPath: {
    value: 0,
    unit: 'Integer',
    id: '961dbc67-0161-41fc-86f7-3eb323960bab',
  },
  grasperRightPath: {
    value: 0,
    unit: 'Integer',
    id: '7ba13984-aab2-446e-91d9-296f9e726b65',
  },
};
